import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';
import { skSK } from '@material-ui/core/locale';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#ec4f30'
    },
    secondary: {
      main: '#442C3D',
      mainGradient: "linear-gradient(130deg, #442C3D 60%, #ec4f30)",
    },
    tertiary: {
      main: '#5f3f25'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography
}, skSK);

export default theme;
